var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { class: { "md-invalid": _vm.error } },
    [
      _vm.icon ? _c("md-icon", { class: _vm.icon }) : _vm._e(),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("md-textarea", {
        attrs: {
          autofocus: _vm.autofocus,
          disabled: _vm.disabled,
          "md-autogrow": _vm.autogrow,
          readonly: _vm.readonly,
          required: _vm.required,
          value: _vm.value,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter", $event)
          },
        },
        nativeOn: {
          blur: function ($event) {
            return _vm.$emit("blur", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.inlineIcon ? _c("md-icon", { class: _vm.inlineIcon }) : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.flashHintText
          ? _c("span", { staticClass: "md-helper-text" }, [
              _vm._v(_vm._s(_vm.flashHintText)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.flashHintText && _vm.hint
        ? _c("span", { staticClass: "md-helper-text" }, [
            _vm._v(_vm._s(_vm.hint)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "md-error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }